import { Outlet } from 'react-router-dom';

import { Analytics } from './analytics';
import { AutomationStatusBanner } from './automation-status-banner';
import { ChannelsSection } from './channels-section';
import { GeneralRecommendation } from './general-recommendations';
import { PostingUnavailableBanner } from './posting-unavailable-banner';

export function Channels() {
  return (
    <>
      <PostingUnavailableBanner />
      <AutomationStatusBanner />
      <Analytics />
      <GeneralRecommendation />
      <ChannelsSection />
      <Outlet />
    </>
  );
}
